export const formatThisAndThatList = (values: string[]): string =>
  values.join(", ").replace(/,([^,]*)$/, " & $1");
